import { render, staticRenderFns } from "./ChainSearch.vue?vue&type=template&id=60424695&scoped=true&"
import script from "./ChainSearch.vue?vue&type=script&lang=ts&"
export * from "./ChainSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ChainSearch.vue?vue&type=style&index=0&id=60424695&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60424695",
  null
  
)

export default component.exports